import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PropertyErrorModel } from 'libs/shared/src/lib/models/property-error.model';
import { StatusType } from 'libs/shared/src/lib/constants/status.type';
import { FlexLayoutType } from 'libs/shared/src/lib/constants/flex-layout.type';
import { LookupModel } from 'libs/shared/src/lib/models/lookup.model';
import { formatBytes } from '../../utils/format-bytes';
import { DocumentUploadStatus } from '../../constants/document-upload-status.type';

@Component({
  selector: 'jsg-file-upload-detail-view',
  templateUrl: './file-upload-detail.component.html',
  styleUrls: ['./file-upload-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadDetailViewComponent implements OnInit {
  @Input() guid: string;
  @Input() name: string;
  @Input() size: number;
  @Input() pages: number;
  @Input() uploadedOn: Date;
  @Input() progress: number = 100;
  @Input() uploadStatus: DocumentUploadStatus;
  @Input() errors: Array<PropertyErrorModel>;
  @Output() deleteUpload = new EventEmitter<string>();
  @Output() openFile = new EventEmitter<string>();
  @Output() cancelUpload = new EventEmitter();

  public formatBytes = formatBytes;
  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public DocumentUploadStatus = DocumentUploadStatus;
  constructor() {}

  ngOnInit(): void {}

  public onOpenFile = (args) => {
    args?.preventDefault();
    args?.stopPropagation();
    this.openFile.emit(this.guid);
  };

  public onDeleteFile = () => {
    this.deleteUpload.emit(this.guid);
  };
}
